import { Controller } from "@hotwired/stimulus"

// Handles the skill search functionality
export default class extends Controller {
  static targets = ["results"]

  connect() {
    this.timeout = null
  }

  perform(event) {
    clearTimeout(this.timeout)
    
    const query = event.target.value.trim()
    
    if (query === "") {
      this.resultsTarget.classList.add("hidden")
      return
    }

    this.timeout = setTimeout(async () => {
      const response = await fetch(`${this.element.dataset.searchUrl}?query=${encodeURIComponent(query)}`)
      const html = await response.text()
      
      this.resultsTarget.innerHTML = html
      this.resultsTarget.classList.remove("hidden")
    }, 300)
  }

  select(event) {
    event.preventDefault()
    
    const skillId = event.currentTarget.dataset.skillId
    const skillName = event.currentTarget.dataset.skillName
    
    // Find the skill select in the form and set its value
    const skillSelect = document.querySelector('select[name="user_skill[skill_id]"]')
    if (skillSelect) {
      skillSelect.value = skillId
    }
    
    this.resultsTarget.classList.add("hidden")
    this.element.value = skillName
  }
} 